jQuery(document).ready(function ($) {

    $(document).on('click', '.search-help', function (event) {
        event.preventDefault();
        $('#search-help').toggleClass('active');
    });

    var $body = $('body');

    var element = $('.header-wrap');
    $(document).scroll(function () {
        $(element).toggleClass('slim', $(document).scrollTop() >= 60);
    });


    $('.box-slider').bxSlider({
        controls: false,
        mode: 'horizontal',
        pagerCustom: '#bx-pager',
        touchEnabled: false,
        infiniteLoop: false
    });
    $('.slider').bxSlider({
        controls: true,
        mode: 'horizontal',
        pager: false,
        auto: true
    });

    $(".inner-tab").each(function () {
        var cLass = $(this).attr('class'),
            number = '.' + cLass.replace("inner-tab", "").replace(" ", ""),
            pagerNum = '#pager-tabs-' + number.replace(".inner-tab-", "");
        $(number).bxSlider({
            controls: false,
            mode: 'horizontal',
            pagerCustom: pagerNum,
            touchEnabled: false,
            auto: true,
            pause: 15000
        });
    });

    $('.menu-opener').on('click', function (event) {
        event.preventDefault();
        $('#bx-pager').toggleClass('open');
    });
    $('#bx-pager').on('click', 'a', function (event) {
        event.preventDefault();
        var index = $(this).attr('data-slide-index');
        if ($('#bx-pager').hasClass('open')) {
            $('#bx-pager').toggleClass('open');
        }
        if ($(window).width() <= 768) {
            $('#bx-pager').prepend($(this));
        }
        $('#bx-pager a').removeClass('active');
        $(this).addClass('active');
    });

    $('.navb-con').on('click', function (event) {
        event.preventDefault();
        $(this).toggleClass('open');
        $('.mob-nav').toggleClass('open');
    });
    $('.reader-form').on('click', function (event) {
        event.preventDefault;
        $(this).toggleClass('open');
        $('#reader-form').toggleClass('open');

    });
    $('.close-reader-form').on('click', function (event) {
        event.preventDefault();
        $('.reader-form').toggleClass('open');
        $('#reader-form').toggleClass('open');

    });
    $('.log-in').on('click', function (event) {
        if (!$(this).hasClass('log-out')) {
            event.preventDefault();

            $(this).toggleClass('open');
            $('.pop-up-bg').toggleClass('open');
        }
    });

    $('.js-trigger-flickerbook').on('click', function (event) {
        event.preventDefault();
        $('.issue-preview-lightbox').addClass('open');
        $('.issue-preview-lightbox__close').addClass('open');
    });
    $('.issue-preview-lightbox__close').on('click', function (event) {
        $(this).removeClass('open');
        $('.issue-preview-lightbox').removeClass('open');
    });


    if ($('body').hasClass('show-login-popup')) {
        $('.log-in').toggleClass('open');
        $('.pop-up-bg').addClass('open');
    }
    $('#sub-pop-trig').on('click', function () {
        $('.subscription-pop-up').toggleClass('open');
        $('.sub-pop').toggleClass('open');
    });

    var $animated_thumbnails = $('#animated-thumbnails');

    if ($animated_thumbnails.length > 0) {
        window.setupLightgallery = function () {
            window.lightgallery = $('#animated-thumbnails').lightGallery({
                thumbnail: true,
                download: false,
                mode: 'lg-fade',
                selector: 'a'
            });
        };

        window.setupLightgallery();

        $animated_thumbnails.masonry({
            // set itemSelector so .grid-sizer is not used in layout
            itemSelector: 'a',
            // use element for option
            columnWidth: '.grid-sizer',
            gutter: '.gutter-sizer',
            percentPosition: true
        });

        $animated_thumbnails.imagesLoaded(function () {
            $animated_thumbnails.masonry('layout');
        });

    }

    var $scroller = $('.scroller');

    if ($scroller.length > 0) {

        $scroller.slick({
            infinite: true,
            slidesToShow: 4,
            slidesToScroll: 4,
            responsive: [
                {
                    breakpoint: 769,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true
                    }
                }
            ]
        });

    }

    $('.play').on('click', function (event) {
        event.preventDefault();

        $(this).parent().find('.vidpop').addClass('open');
        $(this).parent().find(".vid-conts").find('.vid').clone().prependTo($(this).parent().find(".vidpop").find(".pop-up"));
    });
    $('.vidpop').on('click', function (event) {
        event.preventDefault();
        $(this).removeClass('open');
        $(this).parent().find('.vidpop').find('.pop-up').html(' ');
    });


    $ddForm = $('#gform_wrapper_3');

    if ($ddForm.length > 0) {

        $ddForm.directDebitForm();

    }


    $.ajaxSetup({cache: false});
    $(".post-link").on('click', function (event) {
        event.preventDefault();
        var post_link = $(this).attr("href");
        $("#single-post-container").load(post_link + '?ajax=true');


        $(".popup-bg").addClass('open');
        $('body').css({'overflow-y': 'hidden', 'height': '100%', 'position': 'fixed'});
        window.scrollTo(0, 0);
        return false;
    });
    $("body").on('click', '.close-single', function (event) {
        event.preventDefault();
        $("#single-post-container").html(' ');
        $(".popup-bg").removeClass('open');
        $('body').css({'overflow-y': 'auto', 'height': 'auto', 'position': 'static'});
    });

    /** Subscription user check */
    var $subscriptionForm = $('#gform_2'),
        subscriptionFormTimeout = false;
    var $registeredField = $('#input_2_36');

    if ($subscriptionForm.length > 0) {

        var showSubscriptionLoginForm = function () {
            $registeredField.val('1').change();
            $('#not-registered-intro').hide();
            $('#registered-intro').show();
            triggerGformRecalc();
        };

        var hideSubscriptionLoginForm = function () {
            $registeredField.val('0').change();
            $('#not-registered-intro').show();
            $('#registered-intro').hide();
            triggerGformRecalc();
        };

        $subscriptionForm.on('change keyup', '#input_2_1', function () {

            if (subscriptionFormTimeout) {
                clearTimeout(subscriptionFormTimeout);
            }

            var email = $(this).val();

            if (email.indexOf('@') == -1 || email.indexOf('.') == -1) {
                return;
            }

            subscriptionFormTimeout = setTimeout(function () {

                $(document).trigger('loading', 'Checking email address...');

                $.ajax({
                    url: '/',
                    data: {
                        'sg_check_email_user': email
                    },
                    success: function (response) {
                        $(document).trigger('finished-loading');

                        if (response == '1') {
                            showSubscriptionLoginForm();
                            return;
                        }

                        if (response == '0') {
                            hideSubscriptionLoginForm();
                            return;
                        }
                    }
                });
            }, 3000);
        });

        $subscriptionForm.on('click', '#trigger-login', function (event) {
            event.preventDefault();
            showSubscriptionLoginForm();
        });

        $subscriptionForm.on('click', '#trigger-register', function (event) {
            event.preventDefault();
            hideSubscriptionLoginForm();
        });

    }

    var triggerGformRecalc = function () {
        gf_apply_rules(2, [37, 3, 4, 5, 31, 7, 8, 9, 10, 11, 12, 13, 14, 25, 23, 16, 17, 18, 19, 20, 21, 22, 24, 28, 29, 41]);
    };

    if ($body.hasClass('page-readers-photos')) {
        $body.loadMore();
    }


    /* Full screen loader */
    var $fullscreen_loader = $('#fullscreen-loader');

    $(document).imagesLoaded(function () {
        $fullscreen_loader.attr('style', 'display: none !important;');
    });

    $(document).on('loading', function (event, message) {
        if (typeof message == 'undefined') {
            message = 'Please wait...';
        }

        $fullscreen_loader.find('.loader-message').html(message);
        $fullscreen_loader.attr('style', 'display: block !important;');

    });

    $(document).on('finished-loading', function (event) {
        $fullscreen_loader.attr('style', 'display: none !important;');
    });

    /* My Account Disable Fields */
    $('.disabled').find('input').attr('disabled', 'disabled');


    /* Exact search toggle */
    $('#archive-search-form').archiveSearchForm();
    $('#past-issues-search-form').archiveSearchForm();


    /* Club finder email popups */
    if ($('#clubcontactform').length > 0) {
        var original_club_contact_iframe_source = $('#ajaxformwrapper').find('iframe').attr('src');


        $('#clubfinder').on('click', '.showpopup', function (event) {
            event.preventDefault();

            var popupid = $(this).data('popupid');

            if ($('#' + popupid).length > 0) {

                $('#' + popupid).addClass('open');
                $('#' + popupid).css('display', 'block');
                $('#' + popupid).find('.pop-up-inner').removeClass('loading');
                $('#' + popupid).find('#clubcontactname').text($(this).data('clubname'));
                $('#ajaxformwrapper').find('iframe').attr('src', original_club_contact_iframe_source + '&bgaclub_contact=' + $(this).data('clubid'));

                $('body').addClass('fixedforscrolling');


            }

        });

    }

    $('.popup-container').on('click', '.close', function (event) {

        event.preventDefault();
        var $popup = $('#clubcontactpopup');

        $popup.removeClass('open');
        $popup.css('display', 'none');
        $popup.find('.pop-up-inner').addClass('loading');


    });




    $(document).on('click', '.clubfinder-info-window .btn', function (e) {
        e.preventDefault();
        alert('test');
        window.open($(this).attr('href'));
        return false;
    });

    $(document).on('click', '.clubcontrols a', function (e) {
        e.preventDefault();
        window.open($(this).attr('href') + '?returnurl=' + $body.data('siteurl') + '/club-finder');
        return false;
    });

    $(document).on('open-club-link', function (e, item) {
        window.open($(item).attr('href') + '?returnurl=' + $body.data('siteurl') + '/club-finder');
        return false;
    });

    $(document).on('open-club-contact', function (e, item) {
        var $item = $(item);

        var $popup = $('#clubcontactpopup');

        $popup.addClass('open');
        $popup.css('display', 'block');
        $popup.find('.pop-up-inner').removeClass('loading');
        $popup.find('#clubcontactname').text($item.data('clubname'));

        $popup.find('#input_7_4').val($item.data('clubid'));
        $('body').addClass('fixedforscrolling');

    });

    if ($('.archive-categories').length > 0) {
        if ($(window).width() > 1024) {
            $(".archive-categories").sticky({topSpacing: 175});
        }
    }

    $(window).afterResize(function () {
        if ($('.archive-categories').length > 0) {
            $(".archive-categories").unstick();

            if ($(window).width() > 1024) {
                $(".archive-categories").sticky({topSpacing: 175});
            }
        }
    });

    $reorder = $('#re-order');

    if ($reorder.length > 0) {
        $reorder.on('change', 'input', function (event) {
            $reorder.submit();
        });
    }

    window.addEventListener('message', function(event) {

        var data = event.data;

        if (data == 'forgot-password-goback') {

            window.location = "/account";

        }

    });

    var $sticky_accounts_panel = $('.sticky-accounts-panel');
    if ($sticky_accounts_panel.length > 0) {
      var stickyAccountsPanel = function() {
          $sticky_accounts_panel.unstick();

          if (Modernizr.mq('(min-width: 1025px)')) {
              $sticky_accounts_panel.sticky({topSpacing: ($('.header-wrap').height() * 0.6), bottomSpacing: $('footer').height()});
          }
      };
    stickyAccountsPanel();

      $(window).on('resize', function() {
          stickyAccountsPanel();

      });
    }


    // Subscribe Now Billing Post Code Sync
    $(document).on('keyup', '#input_2_14', function() {
        $('#input_2_44').val($(this).val());
    });

    $(document).on('keyup', '#input_2_22', function() {
        $('#input_2_45').val($(this).val());
    });

    // Subscribe Now Shipping Post Code Sync
    $(document).on('keyup', '#input_2_44', function() {
        $('#input_2_14').val($(this).val());
    });

    $(document).on('keyup', '#input_2_45', function() {
        $('#input_2_22').val($(this).val());
    });

    // My Subscription Billing Post Code Sync
    $(document).on('keyup', '#input_1_17', function() {
        $('#input_1_33').val($(this).val());
    });

    $(document).on('keyup', '#input_1_33', function() {
        $('#input_1_17').val($(this).val());
    });

    // My Subscription Shipping Post Code Sync
    $(document).on('keyup', '#input_1_23', function() {
        $('#input_1_34').val($(this).val());
    });

    $(document).on('keyup', '#input_1_34', function() {
        $('#input_1_23').val($(this).val());
    });




});
